import type { FC } from "react";
import type { OvertimeConfig } from "../../../utils/models";
import { requireTransformedRows, transformOvertimeConfigsForBackend } from "../../../utils/wageRules/forBackend";
import { overtimeConfigFromApi } from "../../../utils/wageRules/fromApi";
import { getOvertimeConfigReasons } from "../../../utils/wageRules/validations";
import { matchOvertimeRows } from "./deepLinkRowMatchers";
import { OvertimeConfigTable } from "./OvertimeConfigTable";
import { useSaveOvertimeConfig } from "./useWageRulesConfig";
import { type RuleSectionProps, WageRulesSection, type WageRulesSectionConfig } from "./WageRulesSection";

const OVERTIME_SECTION: WageRulesSectionConfig<OvertimeConfig> = {
	section: "overtime",
	stored: (settings) => settings.overtimeConfig,
	fromApi: overtimeConfigFromApi,
	forBackend: (rows, roles, jobIds) => requireTransformedRows(transformOvertimeConfigsForBackend(rows, roles, jobIds)),
	reasons: getOvertimeConfigReasons,
	Table: OvertimeConfigTable,
	explainerKey: "team.wageSettings.overtime.explainer",
	dataTestId: "team-wage-settings-overtime",
	matchDeepLinkRows: matchOvertimeRows,
};

/** DAT-905 · Overtime rules on Team → Wage Settings. */
export const OvertimeSection: FC<RuleSectionProps> = ({ settings, isReadOnly, deepLink }) => {
	const save = useSaveOvertimeConfig();
	return <WageRulesSection config={OVERTIME_SECTION} settings={settings} save={save} isReadOnly={isReadOnly} deepLink={deepLink} />;
};
